<template>
  <div class="business">
    <MobileNav />
    <div class="info-wrap">
      <div class="info-title">
        <span>消息列表</span>
      </div>
      <div class="list">
        <div class="switchSite">
          <span class="nxsite insite" @click="clearNews()">全部已读</span>
        </div>
        <div class="newBox">
          <div class="newTitle">
            <span class="tit" style="width: 20%">标题</span>
            <span class="nr">内容</span>
            <span class="time">日期</span>
            <span class="cz">操作</span>
          </div>
          <div class="content" v-for="(item,index) in newsArray" :key="index">
            <span class="tit">{{ item.title }}</span>
            <span class="nr">{{ item.content }}</span>
            <span class="time">{{ item.time }}</span>
            <span v-if="item.isread == 'false'" @click="readNews(index)" style="width: 15%"><span class="readNews cz">未读</span></span>
            <span v-if="item.isread == 'true'" class="noread cz">已读</span>
          </div>
        </div>
        <el-pagination
          background
          layout="prev,pager,next"
          :page-size="pageCount"
          :total="$store.state.news.length"
          @current-change="handleCurrentChange"
          :current-page="pageNum" 
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import MobileNav from "../MobileNav";
import isPlus from "@/js/isPlus";
export default {
  components: {
    MobileNav
  },
  data() {
    return {
      pageNum: 1,
      pageCount: 10,
      newsArray: []
    };
  },
  mounted() {
    var me = this;
    me.getNews()
  },
  sockets: {
    connect: function() {
      var token = localStorage.getItem("jwt");
      if (token) {
        this.$socket.emit("authenticate", { token });
      }
    },
    authenticated: function(data) {
      var token = localStorage.getItem("jwt");
      this.$socket.emit("queryUser", token);
    },
    unauthorized: function(error) {
      console.log('unauthorizederror :>> ', error );
      if (error.message === 'jwt expired') {
        this.$router.push({ path: "/login" });
      }
    },
    getNews: function(data) {
      if (data.data){
        this.$store.state.news = data.data
      }
      if (data.noRead){
        this.$store.state.badge = data.noRead
      }
      if (isPlus && window.plus && data.noRead) {
        plus.runtime.setBadgeNumber(data.noRead);
      }
      this.pageInit()
    },
    setNews: function(data) {
      if(data.state){
        this.$store.state.news[data.index].isread = 'true'
        var item = this.$store.state.news[data.index]
        this.$store.state.news.splice(data.index, 1)
        this.$store.state.news.push(item)
        this.$store.state.badge = this.$store.state.badge-1;
        if (isPlus && window.plus) {
          plus.runtime.setBadgeNumber(this.$store.state.badge-1);
        }
        this.pageInit()
      }
    },
    clearNews: function(data) {
      this.$store.state.news.forEach(item => {
        item.isread = 'true'
      });
      this.$store.state.badge = 0
      if (isPlus && window.plus) {
        plus.runtime.setBadgeNumber(0);
      }
      this.pageInit()
    },
  },
  methods: {
    
    getNews:function(){
      var type,data
      var me = this
      if (me.$store.state.userName) {
        type = 'userName'
        data = me.$store.state.userName
      } else if (me.$store.state.wxAppData){
        type = 'unionid'
        data = me.$store.state.wxAppData
      }
      me.$socket.emit('getNews',{
        type: type,
        data: data
      })
    },
    readNews:function(rows){
      var me = this
      me.$socket.emit('setNews',{
        id: me.$store.state.news[rows].id,
        index: rows
      })
    },
    clearNews: function() {
      var me = this
      var type,data
      if (me.$store.state.userName) {
        type = 'userName'
        data = me.$store.state.userName
      } else if (me.$store.state.wxAppData){
        type = 'unionid'
        data = me.$store.state.wxAppData
      }
      me.$socket.emit('clearNews',{
        type: type,
        data: data
      })
    },
    handleCurrentChange(val) {
      var me = this;
      me.pageNum = val;
      me.pageInit();
    },
    pageInit(){
      this.newsArray = this.$store.state.news.slice(
        (this.pageNum - 1) * this.pageCount,
        this.pageNum * this.pageCount
      );
      this.newsArray.map(i => {
        var index = i.content.indexOf('：')
        i.content = i.content.slice(index + 1)
      })
    }
  },
};
</script>

<style lang="less" scoped>
.business {
  padding-bottom: 20px;
  .tc {
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    float: right;
    width: 200px;
  }
  .info-wrap {
    display: flex;
    margin: 0 auto;
    width: 90vw;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 2vh;
    .info-title {
      text-align: center;
      span {
        display: inline-block;
        text-align: center;
        color: #fff;
        width: 80vw;
        font-size: 18px;
      }
      margin-bottom: 4vh;
      line-height: 5vh;
    }
    .list {
      width: 90vw;
      height: 70vh;
      position: relative;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      padding-top: 1vh;
      .switchSite {
        width: 100%;
        height: 40px;
        margin: 3% 0;
        align-self: center;
        line-height: 40px;
        text-align: left;
        font-size: 12px;
        span {
          height: 25px;
          line-height: 20px;
          display: inline-block;
          cursor: pointer;
          border: 1px solid rgb(148, 146, 146);
          padding: 2px 5px;
          margin-right: 5%;
          border-radius: 8px;
          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
            0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
        }
        .insite{
          color: rgb(33, 162, 245);
        }
      }
      .newBox {
        background-color: #20252f;
        border-radius: 10px;
        font-size: 12px;
        color: #fff;
        box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
        .newTitle {
          height: 36px;
          line-height: 36px;
          display: flex;
          span {
            display: inline-block;
          }
          .tit {
            width: 20%;
          }
          .nr {
            width: 40%;
            padding: 0 5px;
          }
          .time{
            width: 25%;
          }
          .cz {
            width: 15%;
          }
        }
        .content {
          height: auto;
          line-height: 55px;
          border-top: 1px solid #666;
          display: flex;
          align-items: center;
          justify-content: center;
          >span {
            display: inline-block;
          }
          .tit {
            width: 20%;
            padding-left: 5px;
          }
          .nr {
            width: 40%;
            line-height: 15px;
            padding: 0 5px;
          }
          .time{
            width: 25%;
            line-height: 20px;
          }
          .cz {
            width: 15%;
          }
          .readNews {
            color: #4f86ed;
            cursor: pointer;
          }
          .noread {
            color: #666;
          }
        }
      }
      .el-pagination {
        margin-top: 20px;
        padding-bottom: 100px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/mobile/mobileNews.vue